export default "__VITE_ASSET__DW5W729U__"